module.exports = "<div>This is the dashboard view.</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/dashboard/dashboard.html
// module id = 51
// module chunks = 0